<template>
  <div class="order-filter tuolele-main-box">
    <div class="tuolele-main-search tuolele-main-search-item">
      <el-form :inline="true" :model="search">
        <el-form-item label="订单搜索">
          <span v-if="type == 'singing'">
            <el-input
              v-model="search.order_id"
              placeholder="签约/财务单号"
            />
          </span>
          <span v-if="type == 'refund'">
            <el-input
              v-model="search.refund_id"
              placeholder="退款单号"
            />
          </span>
          <el-select v-model="filetr.child" @change="changeSub">
            <el-option label="学员姓名" value="sub_name" />
            <el-option label="学员ID" value="relation_id" />
          </el-select>
          <el-input
            v-if="filetr.child == 'sub_name'"
            v-model="search.sub_name"
            placeholder="请输入学员姓名"
          />
          <el-input
            v-if="filetr.child == 'relation_id'"
            v-model="search.relation_id"
            placeholder="请输入学员Id"
          />
        </el-form-item>
        <el-form-item label="选择时间">
          <el-select v-model="search.time_type">
            <el-option label="创建时间" value="create_time" />
            <el-option label="签约成功时间" value="success_time" />
            <el-option label="最后操作时间" value="modify_time" />
          </el-select>
          <el-date-picker
            v-model="search.begin_time"
            type="date"
            placeholder="选择日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          />
          <span class="select-date">至</span>
          <el-date-picker
            v-model="search.end_time"
            type="date"
            placeholder="选择日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-row type="flex">
          <el-col :span="4">
            <el-form-item label="选择店铺">
              <el-select v-model="search.shop_id">
                <el-option label="全部" value="0" />
                <el-option
                  v-for="(item, index) in shopList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="type == 'singing'" :span="4">
            <el-form-item label="课时类型">
              <el-select v-model="search.order_type">
                <el-option
                  v-for="(item, key) in orderType"
                  :key="key"
                  :label="item"
                  :value="key"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="type == 'singing'" :span="4">
            <el-form-item label="订单类型">
              <el-select v-model="search.kpi_status">
                <el-option label="全部" value="" />
                <el-option label="体验" value="1" />
                <el-option label="新签" value="2" />
                <el-option label="续费" value="4" />
                <el-option label="赠送" value="6" />
                <el-option label="扩科" value="7" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="type == 'singing'" :span="5">
            <el-form-item label="订单审核状态">
              <el-select v-model="search.status">
                <el-option label="全部" value="" />
                <el-option label="待校长审核" value="100" />
                <el-option label="待支付" value="101" />
                <el-option label="待财务审核" value="102" />
                <el-option label="待总部审核" value="103" />
                <el-option label="校长审核失败" value="105" />
                <el-option label="财务审核失败" value="106" />
                <el-option label="总部审核失败" value="107" />
                <el-option label="待签字" value="110" />
                <el-option label="审核成功" value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="type == 'singing'" :span="4">
            <el-form-item label="付款方式">
              <el-select v-model="search.payment">
                <el-option label="全部" value />
                <el-option label="支付宝" value="f2f" />
                <el-option label="微信" value="wxqr" />
                <el-option label="POS支付" value="lkl" />
                <el-option label="直接转账" value="turn" />
                <el-option label="现金支付" value="cash" />
                <el-option label="余额支付" value="balance" />
                <el-option label="大众点评" value="dianping" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="type == 'refund'" :span="5">
            <el-form-item label="订单审核状态">
              <el-select v-model="search.status">
                <el-option label="全部" value="" />
                <el-option label="待销售审核" value="101" />
                <el-option label="待校长审核" value="100" />
                <el-option label="待总部审核" value="105" />
                <el-option label="待财务打款" value="102" />
                <el-option label="审核通过" value="2" />
                <el-option label="审核失败" value="3" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row type="flex" class="button-group">
        <el-button type="primary" @click="updateFilter">查询</el-button>
        <el-button type="info" @click="clearFilter">重置筛选条件</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>

var moment = require('moment')

export default {
  name: 'OrderFilter',
  props: {
    type: String
  },
  data() {
    return {
      search: {
        p: 1,
        limit: 10,
        shop_id: '0',
        time_type: 'create_time',
        begin_time: '',
        end_time: '',
        order_id: '',
        refund_id: '',
        sub_name: '',
        relation_id: '',
        order_type: '',
        kpi_status: '',
        status: '',
        payment: ''
      },
      filetr: {
        child: 'sub_name'
      },
      shopList: [],
      orderType: []
    }
  },
  created() {
    // const date = new Date()
    // const year = date.getFullYear()
    // const month = date.getMonth() + 1
    // const day = date.getDate()
    this.search.begin_time = moment().add(-1, 'M').format('YYYY-MM-DD')
    this.search.end_time = moment().format('YYYY-MM-DD')
  },
  mounted() {
    this.getOrderType()
    this.getMyShopList()
  },
  methods: {
    getOrderType() {
      this.$http.getOrderType().then(res => {
        this.orderType = res.data
      })
    },
    getMyShopList() {
      this.$http.getMyShopList().then(res => {
        this.shopList = res.data
      })
    },
    updateFilter() {
      this.search.p = 1
      const filter = JSON.stringify(this.search)
      this.$emit('updateFilter', JSON.parse(filter))
    },
    clearFilter() {
      for (const key in this.search) {
        if (this.search.hasOwnProperty(key)) {
          this.search[key] = ''
        }
      }
      this.search.shop_id = '0'
      this.search.time_type = 'create_time'
      this.search.p = 1
      this.search.limit = 10
    },
    changeSub(val) {
      val == 'sub_name'
        ? (this.search.relation_id = '')
        : (this.search.sub_name = '')
    }
  }
}
</script>

<style lang="scss">
.order-filter {
  .tuolele-main-search-item {
    margin-bottom: 0;
    // margin-top: 30px;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .el-select,
    .el-input {
      width: 140px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 20px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
